import React from "react";
import RenderResourcesVideos from "./RenderResoursesVideos";

const nationalResourcesVideos = [
  {
    name: "Accessing the Portal",
    link: "https://www.loom.com/embed/40e4fa5e1e17448a94ece2d00f49b0f3?sid=c2e626a6-7bc5-4622-a03f-a363ef0fc8cd",
  },
  {
    name: "Overview of Dashboard",
    link: "https://www.loom.com/embed/966f05e45b88491e98846400b74d6018",
  },
  {
    name: "Adding a GA",
    link: "https://www.loom.com/embed/f6d3c6d3313948008b7b26dd46ffed3e",
  },
  {
    name: "Adding a Broker",
    link: "https://www.loom.com/embed/3e53b9c3e08d4971bd39037c654c470e",
  },
  {
    name: "Adding and Managing Individuals",
    link: "https://www.loom.com/embed/3a78c3f3fa024d6ab6f5829db02f465f",
  },
  {
    name: "Adding an Employer Group",
    link: "https://www.loom.com/embed/04104ca7621146bfa7c8ab23a1806a50",
  },
  {
    name: "GA Signup Process",
    link: "https://www.loom.com/embed/d95dfca892fa4f809df63ecec4eb1845",
  },
  {
    name: "Adding and Assigning Commission Structures",
    link: "https://www.loom.com/embed/e9fe7a861e944cb2b5d535ee45b3ead7",
  },
  {
    name: "Enrollment Process for Clients",
    link: "https://www.loom.com/embed/21cbc5c723d649c690cca9a3905dac6c",
  },
  {
    name: "Broker Signup Process",
    link: "https://www.loom.com/embed/792aea6d515b469ba4cb2c259e3bfcb6",
  },
];

const NationalsResources = () => {
  return (
    <div>
      <RenderResourcesVideos resourcesVideos={nationalResourcesVideos} />
    </div>
  );
};

export default NationalsResources;
